const menu = {
    state: {
        menuName: '',
    },
    mutations: {
        setMenuName(state, val){
            state.menuName = val;
        }
    },
    actions: {

    }
}

export default menu;